module.exports = __webpack_public_path__ + "static/img/Tsunoda.1711da8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tsunoda.jpg
// module id = DwJu
// module chunks = 1